import { Box } from '@betterment/samba-react';

import SettingsControlCard from './components/SettingsControlCard';
import { ControlSettingsProps, Controls } from './components/SettingsControls';

type PortfolioControlsProps = {
  controls?: ControlSettingsProps[];
};

const UserLevelSettings: React.FC<PortfolioControlsProps> = ({ controls = Controls }) => {
  return (
    <Box css={{ display: 'grid', gap: 'space.200', marginBottom: 'space.400' }}>
      {controls.map(controlProps => (
        <SettingsControlCard key={`${controlProps.name} control`} {...controlProps} />
      ))}
    </Box>
  );
};

export default UserLevelSettings;
